import styled from "styled-components";

export const CartPage = styled.div`
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: fixed;
`; 